export enum subtitle {
  FAMILY_NOTES = 'Family Notes',
  STUDENT_NOTES = 'Student Notes',
}
